import type { PermissionDTO, PermissionMap } from '~/types/permissions'
import type { SiteReach } from '~/types/site-scope'
import type { EndpointsRegistry, FetchClient } from '~/api/types'
import { GatewayEndpoints } from '~/api/endpoints/gateway-endpoints'
import { normalizePermissions } from '~/utils/permissions/gate'

interface SiteReachDTO {
  enabled?: boolean
  unrestricted?: boolean
  siteIds?: number[] | null
}

export interface PermissionsService {
  getPermissions: () => Promise<PermissionMap>
  getSiteReach: () => Promise<SiteReach>
}

export const registerEndpoints = (client: FetchClient, registry: EndpointsRegistry): PermissionsService => {
  return {
    getPermissions: async () => {
      try {
        const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.PERMISSIONS_GET)
        const permissionsDTO = await client<PermissionDTO>(url, { method, headers, body })

        return normalizePermissions(permissionsDTO)
      } catch (error) {
        console.error('[Permissions API] Failed to load permissions:', error)
        throw error
      }
    },
    getSiteReach: async () => {
      const { url, method, headers } = registry.createRequest(GatewayEndpoints.AUTH_SITE_REACH_GET)
      const reach = await client<SiteReachDTO>(url, { method, headers })

      return {
        enabled: reach?.enabled === true,
        unrestricted: reach?.unrestricted === true,
        siteIds: reach?.siteIds ?? []
      }
    }
  }
}
